import { SvgIcon, SvgIconProps } from '@mui/material';

export const ShippingRefundIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg viewBox='0 0 28 22' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M11.6875 18H14.3157C15.2459 18 16 17.2459 16 16.3157V2.68427C16 1.75407 15.2459 1 14.3157 1H2.68427C1.75407 1 1 1.75407 1 2.68427V16.3157C1 17.2459 1.75408 18 2.68427 18H5.5'
          stroke='currentColor'
          strokeWidth='2.02'
        />
        <g clipPath='url(#clip0_504_7317)'>
          <path
            d='M13 17.6006H14.6002C15.5002 17.6006 16.3002 16.8006 16.3002 15.9006V4.10059'
            stroke='currentColor'
            strokeWidth='2.02'
            strokeLinecap='round'
          />
          <path
            d='M16.3999 4H21.2999C24.2999 4 26.6999 6.3 26.6999 9.1V15.9C26.6999 16.8 25.8999 17.6 24.8999 17.6H24.2999'
            stroke='currentColor'
            strokeWidth='2.02'
            strokeLinecap='round'
          />
          <path
            d='M8.9 21.0002C10.7778 21.0002 12.3 19.478 12.3 17.6002C12.3 15.7224 10.7778 14.2002 8.9 14.2002C7.02223 14.2002 5.5 15.7224 5.5 17.6002C5.5 19.478 7.02223 21.0002 8.9 21.0002Z'
            stroke='currentColor'
            strokeWidth='2.02'
          />
          <path
            d='M20.6998 21.0002C22.5776 21.0002 24.0998 19.478 24.0998 17.6002C24.0998 15.7224 22.5776 14.2002 20.6998 14.2002C18.822 14.2002 17.2998 15.7224 17.2998 17.6002C17.2998 19.478 18.822 21.0002 20.6998 21.0002Z'
            stroke='currentColor'
            strokeWidth='2.02'
          />
        </g>
        <path
          d='M10.85 5.45264C10.7505 5.11913 10.5687 4.82843 10.3281 4.61795C10.0875 4.40747 9.79913 4.28684 9.5 4.27159H7.5C7.10218 4.27159 6.72064 4.45823 6.43934 4.79047C6.15804 5.12271 6 5.57332 6 6.04317C6 6.51303 6.15804 6.96363 6.43934 7.29587C6.72064 7.62811 7.10218 7.81476 7.5 7.81476H9.5C9.89782 7.81476 10.2794 8.0014 10.5607 8.33364C10.842 8.66588 11 9.11649 11 9.58634C11 10.0562 10.842 10.5068 10.5607 10.839C10.2794 11.1713 9.89782 11.3579 9.5 11.3579H7.5C7.20087 11.3427 6.91245 11.222 6.67187 11.0116C6.43128 10.8011 6.24952 10.5104 6.15 10.1769M8.5 1.5V4.27159M8.5 11.3579V14'
          stroke='currentColor'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <defs>
          <clipPath id='clip0_504_7317'>
            <rect width='25.7' height='18.9' fill='white' transform='translate(2 3)' />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
};
